import Vue from 'vue'
import rrmenu from '../components/nav-bar'
import FqIgnore from '../components/fq-ignore'
import rrLoadingPlaceholder from '../components/rr-loading-placeholder'
import rrappbar from '../components/rr-app-bar'
import VideoCard from '../components/video-card'
import searchInput from '../components/search-input'

const components = {
  rrmenu,
  FqIgnore,
  rrLoadingPlaceholder,
  rrappbar,
  VideoCard,
  'search-input': searchInput
}

Object.entries(components).forEach(([name, component]) => {
  Vue.component(component.name, component)
})
